import React, { useMemo, useState, useEffect } from "react"
import { FaEdit, FaEye } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchEvents } from "../../../redux/actions/event"
import ActionDropdown from "components/ActionDropdown"
import { Button } from "reactstrap"

const UpcomingList = () => {
  document.title = "Upcoming Event List"

  const dispatch = useDispatch()
  const history = useNavigate()

  const eventsState = useSelector(state => state.event)

  const [eventData, setEventData] = useState([])

  const columns = useMemo(
    () => [
      {
        header: "Event Name",
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Date",
        accessorKey: "event_date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Time",
        accessorKey: "time",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Total Seats",
        accessorKey: "total_seats",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Available Seats",
        accessorKey: "available_seats",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => (info.getValue() === 1 ? "Active" : "Inactive"),
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <ActionDropdown buttonLabel="Edit & View">
              <button
                className="dropdown-item"
                onClick={() => history(`/events/edit-event/${row.url}`)}
                title="Edit Event"
              >
                <span>Edit Event</span>
                <FaEdit />
              </button>
              <button
                className="dropdown-item btn btn-sm btn-info"
                onClick={() => history(`/events/view-event/${row.url}`)}
                title="View Event"
              >
                <span>View Bookings</span>
                <FaEye />
              </button>
            </ActionDropdown>
            // <div>
            //   <button
            //     className="btn btn-sm btn-primary me-2"
            //     onClick={() => history(`/events/edit-event/${row.url}`)}
            //     title="Edit Event"
            //   >
            //     <span>Edit Event</span>
            //     <FaEdit />
            //   </button>
            //   <button
            //     className="btn btn-sm btn-info"
            //     onClick={() => history(`/events/view-event/${row.url}`)}
            //     title="View Event"
            //   >
            //     <span>View Bookings</span>
            //     <FaEye />
            //   </button>
            // </div>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(fetchEvents({ filter: "all-upcoming" }))
  }, [dispatch])

  useEffect(() => {
    console.log("eventsState", eventsState)
    if (eventsState && Array.isArray(eventsState.allUpcomingEventList)) {
      setEventData(eventsState.allUpcomingEventList)
    }
  }, [eventsState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h2 className="nom-title mb-0">Upcoming List</h2>
          <Button
            color="primary"
            onClick={() => (window.location.href = "/events/add-event")}
          >
            Add Event
          </Button>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={eventData || []}
          isGlobalFilter={true}
          isCustomPageSize={true}
          isPagination={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4 nominee-tbl-wrapper"
        />
      </div>
    </div>
  )
}

export default UpcomingList
